import React from 'react';
import {createRoot} from 'react-dom/client';
import './sentry';
import App from './App';
import './index.css';

const root = createRoot(document.querySelector('#root')!);
root.render(<App />);
